import  { useState } from 'react'

import 'jqueryui'

import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiCodeBlock,
  EuiAccordion,
  EuiButton,
  EuiFormRow,
  EuiModal,
  EuiModalHeader,
  EuiModalHeaderTitle,
  EuiModalBody,
  EuiModalFooter,
  EuiButtonEmpty,
  EuiForm,
  EuiFieldText,
} from '@elastic/eui'

import KpiService from '../services/kpi.service'


function AdminKpisModal({
  isModalVisible,
  closeModal,
  compute,
  kpiDocument,
  kpiCode,
}) {
  const [kpiAdminDocument, setKpiAdminDocument] = useState(kpiDocument)

  const { keys } = Object
  const isObject = (a) => typeof a === 'object' && !Array.isArray(a)
  const merge = (a, b) =>
    isObject(a) && isObject(b)
      ? deepMerge(a, b)
      : isObject(a) && !isObject(b)
      ? a
      : b
  const coalesceByKey = (source) => (acc, key) =>
    (acc[key] && source[key]
      ? (acc[key] = merge(acc[key], source[key]))
      : (acc[key] = source[key])) && acc
  /**
   * Merge all sources into the target
   * overwriting primitive values in the the accumulated target as we go (if they already exist)
   * @param {*} target
   * @param  {...any} sources
   */
  const deepMerge = (target, ...sources) =>
    sources.reduce(
      (acc, source) => keys(source).reduce(coalesceByKey(source), acc),
      target,
    )

  function onChangeField(elem) {
    if (elem.target.name) {
      var keys = elem.target.name
      var tempObject = {}
      var container = tempObject
      keys.split('.').map((k, i, values) => {
        container = container[k] =
          i == values.length - 1 ? elem.target.value : {}
      })

      setKpiAdminDocument(deepMerge(kpiDocument, tempObject))
    }
  }

  const submitFormModal = () => {
    KpiService.upsertKpi(kpiCode, kpiAdminDocument)
      .then((data) => {
        console.log(data)
      })
      .catch((err) => console.log(err))
  }

  const handleSubmit = (evt) => {
    evt.preventDefault()
  }

  const formModal = () => {
    if (kpiDocument) {
      return (
        <EuiForm id="modalForm" component="form" onSubmit={handleSubmit}>
          {KpiService.kpisGroup
            .filter((key) => {
              return ['perimetre_supervise', 'log'].indexOf(key) > -1
            })
            .map((key) => {
              return (
                <EuiAccordion
                  key={key}
                  id={'accordion_' + key}
                  buttonContent={
                    KpiService.kpisLabel[KpiService.kpisGroup.indexOf(key)]
                  }
                >
                  <EuiFlexGroup>
                    <EuiFlexItem>
                      <EuiFormRow label="Nom du rapport :">
                        <EuiFieldText
                          id={key + '.green.report'}
                          name={key + '.report'}
                          defaultValue={
                            kpiDocument[key]?.report
                              ? kpiDocument[key].report
                              : ''
                          }
                          onChange={(e) => onChangeField(e, 'string', key)}
                        />
                      </EuiFormRow>
                    </EuiFlexItem>
                  </EuiFlexGroup>
                </EuiAccordion>
              )
            })}
        </EuiForm>
      )
    }
  }

  let modal
  if (isModalVisible) {
    modal = (
      <EuiModal id="modalAdminKpis" onClose={closeModal}>
        <EuiModalHeader>
          <EuiModalHeaderTitle>
            <h1>Administration KPIS</h1>
            <h2>Node Confluence #{kpiCode}</h2>
          </EuiModalHeaderTitle>
        </EuiModalHeader>

        <EuiModalBody>
          {formModal()}
          <EuiCodeBlock
            language="json"
            overflowHeight={300}
            isCopyable
            isVirtualized
          >
            {JSON.stringify(kpiDocument, null, 2)}
          </EuiCodeBlock>
        </EuiModalBody>

        <EuiModalFooter>
          <EuiButtonEmpty onClick={closeModal}>Annuler</EuiButtonEmpty>

          <EuiButton
            type="submit"
            onClick={() => {
              submitFormModal()
              closeModal()
            }}
            fill
          >
            Sauvegarder
          </EuiButton>

          <EuiButton
            type="button"
            onClick={() => {
              submitFormModal()
              compute(kpiCode, function () {
                closeModal()
              })
            }}
            fill
          >
            Regénerer agrégation
          </EuiButton>
        </EuiModalFooter>
      </EuiModal>
    )
  }

  return <>{modal}</>
}

export default AdminKpisModal
